import React, { useState, useEffect } from 'react'
import { Text } from '../../constants/TextConstants'
import PropTypes from 'prop-types'
import { Pagination } from '../Pagination'
import { epagAPI } from '../../API/epagAPI'
import { ErrorText } from '../EditProfile/Inputs/styles'
import { displayUTCDate, isAdminRole, useIfMountedEffect } from '../../utils/utils'
import { HeaderMenu } from '../HeaderMenu'
import { useSave } from '../../Context/saveContext'
import {
  HeaderWrapper,
  Title,
  TableTitle,
  InfoRowWrapper,
  InfoRow,
  InfoRowIcons,
  EmailInfoRowField,
  EmailInfoRow,
  CountryInfoRowField,
  CountryInfoRow,
  InfoRowField,
  InfoRowInToolTip,
  NameInfoRowField,
  ExportProfileWrapper,
  RowsWrapper,
  SpinnerWrapper,
  TableWrapper,
  UserListWrapper
} from './styles'
import { PERMISSION_CODES } from '../../constants/permissions'
import { ExportProfile } from '../Modals/ExportProfile'
import FilterExport from './AdvancedSearchAndExport'
import { BqTooltip, BqCheckbox, BqSpinner } from '@beeq/react'
import { useSort } from '../../hooks/useSort'
import { ActionsCell } from './ActionsCell'
import { NoDataFound } from './NoDataFound'
import { mockUsers } from './mockData'
import SortButton from '../SortButton'

const optionsList = [
  'disciplines',
  'roles',
  'coreSkills',
  'grades',
  'countries',
  'deliveryUnits',
  'spokenLanguages',
  'certifications',
  'programmingLanguages',
  'databases',
  'toolTechniques'
]
const defaultAdvancedSearchFilter = {
  spokenLanguages: [],
  certification: [],
  programmingLanguages: [],
  databases: [],
  toolTechnique: [],
  country: [],
  DU: [],
  grade: [],
  core_skill: [],
  discipline: [],
  lastUpdateFrom: '',
  lastUpdateTo: '',
  completion: [0, 100],
  status: 'Active',
  globalSearch: ''
}

export const Profiles = ({ hideHeaderMenu = true }) => {
  const [userListFiltered, setUserListFiltered] = useState(mockUsers)
  const [isLoading, setIsLoading] = useState(false)
  const [loadingText, setLoadingText] = useState(Text.GenericLoading)
  const [ErrorFetch, setErrorFetch] = useState('')
  const [actualPage, setActualPage] = useState(1)
  const [totalItems, setTotalItems] = useState(20)
  const [itemsPerPage, setItemsPerPage] = useState(10)
  const [sortState, toggleSort] = useSort({ name: { order: 'asc' } })
  const [advancedSearchOptions, setAdvancedSearchOptions] = useState({})
  const { userProfile, userPermissions, permissionsQuantity } = useSave()
  const [selectedUsersToExport, setSelectedUsersToExport] = useState([])
  const [exportAllUsersExceptOf, setExportAllUsersExceptOf] = useState([])
  const [selectAll, setSelectAll] = useState(false)
  const [advancedSearchFilterData, setAdvancedSearchFilterData] = useState(defaultAdvancedSearchFilter)
  const resetAdvancedSearchFilterData = () => {
    const { globalSearch } = advancedSearchFilterData
    setAdvancedSearchFilterData({ ...defaultAdvancedSearchFilter, globalSearch })
    handleSearch({ ...defaultAdvancedSearchFilter, globalSearch })
  }

  useIfMountedEffect(() => {
    if (userProfile) {
      setIsLoading(true)
      getProfiles(filtersToRequest(advancedSearchFilterData))
    }
  }, [userProfile, actualPage, itemsPerPage, sortState, advancedSearchFilterData])

  useIfMountedEffect(() => {
    const localFilters = JSON.parse(sessionStorage.getItem('selectedFilters-profiles'))
    const selectedFilters = localFilters ?? userProfile?.settings?.filters ?? []
    sessionStorage.setItem('selectedFilters-profiles', JSON.stringify(selectedFilters))
  }, [userProfile?.settings?.filters])

  useEffect(() => {
    setTotalItems(userListFiltered.length)
  }, [userListFiltered])

  useEffect(() => {
    if (selectAll) {
      setSelectedUsersToExport('all')
    } else {
      setSelectedUsersToExport([])
      setExportAllUsersExceptOf([])
    }
  }, [selectAll])

  useEffect(() => {
    GetOptions(optionsList)
  }, [])

  const validateCheckedStatus = (email) => {
    if (selectAll) {
      const shouldExport = !exportAllUsersExceptOf.includes(email)
      return shouldExport
    }
    return selectedUsersToExport.includes(email)
  }

  const addSpinProperty = (list) => {
    return list.map((item) => {
      const getFullName = (iname, ilastname) => iname.concat(' ').concat(ilastname)
      const userCompleted = {
        ...item,
        name: item.name,
        lastName: item.lastName,
        fullName: getFullName(item.name, item.lastName),
        email: item.email,
        position: item.role,
        discipline: item.discipline,
        coreSkill: item.core_skill,
        grade: item.grade,
        DU: item.DU,
        country: item.country
      }
      return { ...userCompleted, spinStatus: false }
    })
  }

  const onPageSizeChangeHandler = (pageSize) => {
    setActualPage(1)
    setItemsPerPage(pageSize)
  }

  const canUserExportProfiles = (userPermissions, permissionCode) => {
    return userPermissions.includes(permissionCode)
  }

  const filtersToRequest = (filters) => {
    const auxFilters = { ...filters }
    Object.keys(filters).forEach((item) => {
      if (filters[item] === 'all' || filters[item] === '' || filters[item].length === 0) {
        delete auxFilters[item]
      }

      if (item === 'completion') {
        if (filters[item][0] !== 0) {
          auxFilters.completionFrom = filters[item][0].toString()
        }
        if (filters[item][1] !== 100) {
          auxFilters.completionTo = filters[item][1].toString()
        }
        delete auxFilters[item]
      }
      if (item === 'coreSkill' && filters[item] !== 'all') {
        auxFilters.core_skill = filters[item]
        delete auxFilters[item]
      }
      if (item === 'lastUpdateFrom' || item === 'lastUpdateTo') {
        const date = filters[item].split('/')
        if (date.length === 3) {
          auxFilters[item] = `${date[2]}-${date[0]}-${date[1]}`
        }
      }
    })
    return auxFilters
  }

  const changeCheckboxHandler = (event, email) => {
    const isCheckedDifferentFromSelectAll = event.target.checked !== selectAll
    const shouldUpdateExportExceptOf = selectAll && exportAllUsersExceptOf.includes(email)
    const shouldUpdateSelectedUsersToExport = !selectAll && selectedUsersToExport.includes(email)

    switch (true) {
      case isCheckedDifferentFromSelectAll:
        handleCheckboxChange(email)
        break
      case shouldUpdateExportExceptOf:
        setExportAllUsersExceptOf((prevUsersEmail) => prevUsersEmail.filter((userEmail) => userEmail !== email))
        break
      case shouldUpdateSelectedUsersToExport:
        setSelectedUsersToExport((prevUsersEmail) => prevUsersEmail.filter((userEmail) => userEmail !== email))
        break
    }
  }

  const handleCheckboxChange = (email) => {
    const allUsersSelected = selectedUsersToExport === 'all'

    if (allUsersSelected) {
      const updatedExportExceptList = exportAllUsersExceptOf.includes(email)
        ? exportAllUsersExceptOf.filter((exportEmail) => exportEmail !== email)
        : [...exportAllUsersExceptOf, email]
      setExportAllUsersExceptOf(updatedExportExceptList)
    } else {
      const updatedSelectedUsersList = selectedUsersToExport.includes(email)
        ? selectedUsersToExport.filter((exportEmail) => exportEmail !== email)
        : [...selectedUsersToExport, email]
      setSelectedUsersToExport(updatedSelectedUsersList)
    }
  }

  const handleSearch = (filters) => {
    setAdvancedSearchFilterData((prev) => ({ ...prev, ...filters }))
    setActualPage(1)
    setSelectedUsersToExport([])
    setExportAllUsersExceptOf([])
    setSelectAll(false)
  }

  const GetOptions = (options) => {
    epagAPI.GetOptions(options).then((response) =>
      setAdvancedSearchOptions({
        discipline: response.disciplines,
        role: response.roles,
        coreSkill: response.coreSkills,
        grade: response.grades,
        country: response.countries,
        DU: response.deliveryUnits,
        languages: response.spokenLanguages,
        certifications: response.certifications,
        programmingLanguages: response.programmingLanguages,
        databases: response.databases,
        toolsAndTechniques: response.toolTechniques
      })
    )
  }

  const getProfiles = (filters = {}) => {
    // the next line is commented to avoid the next warning
    // Warning: Can't perform a React state update on an unmounted component.
    // This is a no-op, but it indicates a memory leak in your application.
    // To fix, cancel all subscriptions and asynchronous tasks in a useEffect cleanup function
    // setIsLoading(true)

    const { status, ...restFilters } = filters
    epagAPI
      .GetProfiles(
        actualPage,
        itemsPerPage,
        Object.keys(sortState).length === 0 ? { name: { order: 'asc' } } : sortState,
        restFilters,
        status
      )
      .then((response) => {
        setUserListFiltered(addSpinProperty(response.paginatedResults))
        setIsLoading(false)
        setErrorFetch('')
        setTotalItems(response.totalRecords)
      })
      .catch((error) => {
        setErrorFetch(error.message)
        setIsLoading(false)
      })
  }

  const evaluateExportUserCheckbox = (selectedUsersToExport, exportAllUsersExceptOf, email) => {
    const isNotExcludedEmail = !exportAllUsersExceptOf.includes(email)

    if (selectAll && isNotExcludedEmail) {
      return true
    }

    return selectedUsersToExport.includes(email)
  }

  const generateUsersList = () => {
    return userListFiltered.map((user, index) => {
      return (
        <InfoRowWrapper
          key={index}
          className={
            evaluateExportUserCheckbox(selectedUsersToExport, exportAllUsersExceptOf, user.email) ? 'active' : ''
          }>
          {canUserExportProfiles(userPermissions, PERMISSION_CODES.exportProfiles.code) && (
            <InfoRowField key={index} $align='left' $width='5%' $minWidth='4%'>
              <BqCheckbox
                key={user.email}
                data-testid={'selectUser-' + index}
                name={'selectUser-' + index}
                checked={validateCheckedStatus(user.email)}
                value={user.email}
                onBqChange={(event) => changeCheckboxHandler(event, user.email)}
              />
            </InfoRowField>
          )}
          <NameInfoRowField $align='left' $width='12.5%' $minWidth='10%'>
            <BqTooltip placement='top' displayOn='hover' data-testid={'full-name-' + index}>
              {user.fullName}
              <InfoRowInToolTip slot='trigger'>{user.fullName}</InfoRowInToolTip>
            </BqTooltip>
          </NameInfoRowField>
          <EmailInfoRowField $align='left' $width='12.5%' $minWidth='10%' data-testid={'email-' + index}>
            <BqTooltip placement='top' displayOn='hover'>
              {user.email}
              <EmailInfoRow slot='trigger'>{user.email}</EmailInfoRow>
            </BqTooltip>
          </EmailInfoRowField>
          <CountryInfoRowField $align='left' $width='10%' $minWidth='8%' data-testid={'country-' + index}>
            <BqTooltip placement='top' displayOn='hover'>
              {user.country}
              <CountryInfoRow slot='trigger'>{user.country}</CountryInfoRow>
            </BqTooltip>
          </CountryInfoRowField>
          <InfoRow $align='left' $width='7%' $minWidth='6%' data-testid={'du-' + index}>
            {user.DU}
          </InfoRow>
          <InfoRow $align='left' $width='8.5%' $minWidth='7.5%' data-testid={'grade-' + index}>
            {user.grade}
          </InfoRow>
          <InfoRowField $align='left' $width='10%' $minWidth='8%'>
            <BqTooltip placement='top' displayOn='hover' data-testid={'core-skill-' + index}>
              {user.coreSkill}
              <InfoRowInToolTip slot='trigger'>{user.coreSkill}</InfoRowInToolTip>
            </BqTooltip>
          </InfoRowField>
          <InfoRowField $align='left' $width='11%' $minWidth='11%' data-testid={'discipline-' + index}>
            <BqTooltip placement='top' displayOn='hover'>
              {user.discipline}
              <InfoRowInToolTip slot='trigger'>{user.discipline}</InfoRowInToolTip>
            </BqTooltip>
          </InfoRowField>
          <InfoRow
            $align='left'
            $width={isAdminRole(userProfile?.userRole, userPermissions.length, permissionsQuantity) ? '9.5%' : '10.5%'}>
            {displayUTCDate(user.lastUpdate)}
          </InfoRow>
          {isAdminRole(userProfile?.userRole, userPermissions.length, permissionsQuantity) && (
            <InfoRow $width='15%' $minWidth='12%'>
              {user.profile_filling_percentage ? `${Math.round(user.profile_filling_percentage * 10) / 10}  %` : '0 %'}
            </InfoRow>
          )}
          <InfoRowIcons $width='7.5%'>
            <ActionsCell
              userEmail={user.email}
              setIsLoading={setIsLoading}
              setLoadingText={setLoadingText}
              getProfiles={getProfiles}
              filtersToRequest={filtersToRequest}
              advancedSearchFilterData={advancedSearchFilterData}
            />
          </InfoRowIcons>
        </InfoRowWrapper>
      )
    })
  }

  const evaluateExportButtonDisabled = (selectedUsersToExport, totalItems) => {
    const noUsersSelected = !selectAll && selectedUsersToExport.length === 0
    const allUsersSelected = selectAll && exportAllUsersExceptOf.length === totalItems
    return noUsersSelected || allUsersSelected
  }

  const calculateExportCounter = (selectedUsersToExport, exportAllUsersExceptOf) => {
    if (selectAll) {
      return exportAllUsersExceptOf.length === 0 ? totalItems : totalItems - exportAllUsersExceptOf.length
    } else {
      return selectedUsersToExport.length > 0 ? selectedUsersToExport.length : null
    }
  }

  return (
    <UserListWrapper>
      {!hideHeaderMenu && (
        <HeaderMenu mail={userProfile?.email} defaultNavName={Text.AdminPanel} hideEditButton={false} />
      )}
      <Title className='h4 bold' data-testid='title-profile'>
        {Text.Profiles}
      </Title>
      {userPermissions.includes(PERMISSION_CODES.advancedSearch.code) && (
        <FilterExport
          advancedSearchOptions={advancedSearchOptions}
          advancedSearchFilterData={advancedSearchFilterData}
          handleSearch={handleSearch}
          resetAdvancedSearchFilterData={resetAdvancedSearchFilterData}
          exportBtnComponent={
            canUserExportProfiles(userPermissions, PERMISSION_CODES.exportProfiles.code) && (
              <ExportProfile
                profilesToExport={{
                  selectedUsersToExport,
                  exportAllUsersExceptOf,
                  filters: filtersToRequest(advancedSearchFilterData)
                }}
                setIsLoading={setIsLoading}
                setLoadingText={setLoadingText}
                disabled={evaluateExportButtonDisabled(selectedUsersToExport, totalItems)}
                counter={calculateExportCounter(selectedUsersToExport, exportAllUsersExceptOf)}
              />
            )
          }
        />
      )}
      {canUserExportProfiles(userPermissions, PERMISSION_CODES.exportProfiles.code) &&
        !userPermissions.includes(PERMISSION_CODES.advancedSearch.code) && (
          <ExportProfileWrapper>
            <ExportProfile
              profilesToExport={{
                selectedUsersToExport,
                exportAllUsersExceptOf,
                filters: filtersToRequest(advancedSearchFilterData)
              }}
              setIsLoading={setIsLoading}
              setLoadingText={setLoadingText}
              disabled={evaluateExportButtonDisabled(selectedUsersToExport, totalItems)}
              counter={calculateExportCounter(selectedUsersToExport, exportAllUsersExceptOf)}
            />
          </ExportProfileWrapper>
      )}

      {!userListFiltered.length && <NoDataFound resetAdvancedSearchFilterData={resetAdvancedSearchFilterData} />}

      {!!userListFiltered.length && (
        <>
          <TableWrapper>
            <HeaderWrapper>
              {canUserExportProfiles(userPermissions, PERMISSION_CODES.exportProfiles.code) && (
                <TableTitle $width='5%' $minWidth='4%'>
                  <BqCheckbox
                    data-testid='exportAll'
                    name='exportAll'
                    value='all'
                    checked={selectAll}
                    onBqChange={(event) => setSelectAll(event.detail.checked)}
                  />
                </TableTitle>
              )}
              <TableTitle $width='12.5%' $minWidth='10%' data-testid='name-header-profile' id='name'>
                <span>{Text.Name}</span> <SortButton name='name' sortOrder={sortState?.name} toggleSort={toggleSort} />
              </TableTitle>
              <TableTitle
                $width='12.5%'
                $minWidth='10%'
                data-testid='email-header-profile'
                style={{ flexShrink: 2 }}
                id='email'>
                <span>{Text.Email}</span>
              </TableTitle>
              <TableTitle
                $width='10%'
                $minWidth='8%'
                $leftPadding='1.2rem'
                data-testid='country-header-profile'
                id='country'>
                <span>{Text.Country}</span>
                <SortButton name='country' sortOrder={sortState?.country} toggleSort={toggleSort} />
              </TableTitle>
              <TableTitle $width='7%' $minWidth='6%' data-testid='du-header-profile' id='du'>
                <span>{Text.DU}</span> <SortButton name='DU' sortOrder={sortState?.DU} toggleSort={toggleSort} />
              </TableTitle>
              <TableTitle
                $width='8.5%'
                $minWidth='7.5%'
                $leftPadding='0.75rem'
                data-testid='grade-header-profile'
                id='grade'>
                <span>{Text.Grade}</span>
                <SortButton name='grade' sortOrder={sortState?.grade} toggleSort={toggleSort} />
              </TableTitle>
              <TableTitle
                $width='10%'
                $minWidth='8%'
                $leftPadding='0.75rem'
                data-testid='core-skill-header-profile'
                id='coreskill'>
                <span style={{ textWrap: 'wrap' }}>{Text.CoreSkill}</span>
                <SortButton name='core_skill' sortOrder={sortState?.core_skill} toggleSort={toggleSort} />
              </TableTitle>
              <TableTitle
                $width='11%'
                $minWidth='11%'
                $leftPadding='0.75rem'
                data-testid='discipline-header-profile'
                id='discipline'>
                <span>{Text.Discipline}</span>
                <SortButton name='discipline' sortOrder={sortState?.discipline} toggleSort={toggleSort} />
              </TableTitle>
              <TableTitle
                data-testid='last-update-header-profile'
                $width={
                  isAdminRole(userProfile?.userRole, userPermissions.length, permissionsQuantity) ? '9.5%' : '10.5%'
                }>
                <span style={{ textWrap: 'wrap' }}>{Text.LastUpdate}</span>
                <SortButton name='lastUpdate' sortOrder={sortState?.lastUpdate} toggleSort={toggleSort} />
              </TableTitle>
              {isAdminRole(userProfile?.userRole, userPermissions.length, permissionsQuantity) && (
                <TableTitle
                  $textAlign='center'
                  $width='15%'
                  $minWidth='12%'
                  data-testid='completation-percentage-header-profile'
                  id='completation'>
                  <span>{Text.CompletionPercentage}</span>
                  <SortButton
                    name='profile_filling_percentage'
                    sortOrder={sortState?.profile_filling_percentage}
                    toggleSort={toggleSort}
                  />
                </TableTitle>
              )}
              <TableTitle
                $textAlign='center'
                $width='7.5%'
                $leftPadding='0'
                $height='28px'
                data-testid='action-header-profile'>
                {Text.Actions}
              </TableTitle>
            </HeaderWrapper>
            {isLoading ? (
              <SpinnerWrapper>
                <BqSpinner size='large' text-position='bellow' style={{ top: '140px' }} data-testid='spinner-profile'>
                  <span>{loadingText}</span>
                </BqSpinner>
              </SpinnerWrapper>
            ) : (
              <RowsWrapper>{generateUsersList()}</RowsWrapper>
            )}
          </TableWrapper>
          <Pagination
            currentPage={actualPage}
            totalItems={totalItems}
            defaultPageSize={itemsPerPage}
            onPageSizeChange={onPageSizeChangeHandler}
            onPageChange={setActualPage}
            pageSizeControlSuffix={Text.Profiles}
          />
        </>
      )}
      {ErrorFetch !== '' && <ErrorText>{ErrorFetch}</ErrorText>}
    </UserListWrapper>
  )
}

Profiles.propTypes = {
  hideHeaderMenu: PropTypes.bool
}
